import { render, staticRenderFns } from "./c_member_shoppingCredit.vue?vue&type=template&id=44c49224&scoped=true"
import script from "./c_member_shoppingCredit.vue?vue&type=script&lang=js"
export * from "./c_member_shoppingCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c49224",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c49224')) {
      api.createRecord('44c49224', component.options)
    } else {
      api.reload('44c49224', component.options)
    }
    module.hot.accept("./c_member_shoppingCredit.vue?vue&type=template&id=44c49224&scoped=true", function () {
      api.rerender('44c49224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_member_shoppingCredit.vue"
export default component.exports